(function(){
 const instances=new WeakSet();
 function init(root){
  if(instances.has(root))return;instances.add(root);
  let variants;
  try{variants=JSON.parse(root.querySelector('[data-cp-variants]').textContent)}catch(e){return}
  if(!Array.isArray(variants)||!variants.length)return;
  const available=variants.filter(v=>v.available);
  const groups=[...root.querySelectorAll('[data-cp-group]')];
  const input=root.querySelector('[data-cp-variant]');
  const form=root.querySelector('[data-cp-form]');
  const price=root.querySelector('[data-cp-price]');
  const compare=root.querySelector('[data-cp-compare]');
  const title=root.querySelector('[data-cp-title]');
  const add=root.querySelector('[data-cp-add]');
  const addText=root.querySelector('[data-cp-add-text]');
  const status=root.querySelector('[data-cp-status]');
  const payment=root.querySelector('[data-cp-payment]');
  let currency='CAD';
  try{currency=JSON.parse(root.querySelector('[data-cp-currency]').textContent)}catch(e){}
  const fmt=c=>new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency}).format(Number(c)/100);
  let current=variants.find(v=>String(v.id)===String(input.value))||available[0]||variants[0];
  let choices=(current.options||[]).slice();
  function refresh(){
   groups.forEach((group,i)=>{
    const label=group.querySelector('[data-cp-label]');
    if(label)label.textContent=choices[i]||'';
    group.querySelectorAll('[data-cp-choice]').forEach(button=>{
     const value=button.dataset.cpValue;
     // Only matching upstream options restrict a downstream choice; no stale future choices.
     const possible=available.some(v=>String(v.options?.[i])===value && v.options.slice(0,i).every((x,k)=>String(x)===choices[k]));
     button.hidden=!possible;
     button.disabled=!possible;
     const selected=possible && value===choices[i];
     button.classList.toggle('is-selected',selected);
     button.setAttribute('aria-pressed',String(selected));
    });
   });
  }
  function notifyPayment(){
   // Shopify's native accelerated checkout observes the product form's variant input.
   input.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function render(variant,updateUrl=true){
   if(!variant)return;
   current=variant;choices=(variant.options||[]).slice();input.value=variant.id;
   title.textContent=variant.title;price.textContent=fmt(variant.price);
   compare.hidden=!(variant.compare_at_price>variant.price);
   if(!compare.hidden)compare.textContent=fmt(variant.compare_at_price);
   add.disabled=!variant.available;addText.textContent=variant.available?'Add to bag':'Unavailable';
   if(payment)payment.hidden=!variant.available;
   refresh();notifyPayment();
   if(updateUrl)try{const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState(history.state,'',u)}catch(e){}
   if(variant.featured_media?.id){const s=root.querySelector('[data-cp-media="'+variant.featured_media.id+'"]');if(s)showSlide(Number(s.dataset.cpSlide));}
  }
  function select(index,value){
   let desired=choices.slice(0,index);desired[index]=value;
   let candidates=available.filter(v=>v.options.slice(0,index+1).every((x,k)=>String(x)===String(desired[k])));
   if(!candidates.length)return;
   // Prefer retaining downstream choices only when the complete combination exists.
   const full=candidates.find(v=>v.options.slice(index+1).every((x,k)=>String(x)===String(choices[index+1+k])));
   render(full||candidates[0]);
  }
  root.querySelectorAll('[data-cp-choice]').forEach(button=>button.addEventListener('click',()=>{
   if(!button.hidden&&!button.disabled)select(Number(button.dataset.cpPosition),button.dataset.cpValue);
  }));
  let slides=[...root.querySelectorAll('[data-cp-slide]')],thumbs=[...root.querySelectorAll('[data-cp-thumb]')],active=0;
  function showSlide(n){if(!slides.length)return;active=(n+slides.length)%slides.length;slides.forEach((s,i)=>{s.hidden=i!==active;s.classList.toggle('is-active',i===active);if(i!==active)s.querySelector('video')?.pause()});thumbs.forEach((b,i)=>{b.classList.toggle('is-active',i===active);b.setAttribute('aria-pressed',String(i===active))})}
  root.querySelector('[data-cp-prev]')?.addEventListener('click',()=>showSlide(active-1));
  root.querySelector('[data-cp-next]')?.addEventListener('click',()=>showSlide(active+1));
  thumbs.forEach(b=>b.addEventListener('click',()=>showSlide(Number(b.dataset.cpThumb))));
  const qty=root.querySelector('[data-cp-qty]');
  root.querySelector('[data-cp-minus]')?.addEventListener('click',()=>qty.value=Math.max(1,(Number(qty.value)||1)-1));
  root.querySelector('[data-cp-plus]')?.addEventListener('click',()=>qty.value=Math.min(99,(Number(qty.value)||1)+1));
  root.querySelector('[data-cp-copy]')?.addEventListener('click',async e=>{try{await navigator.clipboard.writeText('BFCM25');e.currentTarget.textContent='Copied ✓'}catch(err){e.currentTarget.textContent='BFCM25'}});
  form.addEventListener('submit',async e=>{
   if(!window.fetch||!current.available)return;
   const submitter=e.submitter;
   if(submitter && !submitter.matches('[data-cp-add]'))return;
   e.preventDefault();add.disabled=true;addText.textContent='Adding…';
   const url=(form.action||'').replace(/\/add(?:\?.*)?$/,'/add.js');
   try{
    const response=await fetch(url,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
    const data=await response.json();
    if(!response.ok)throw Error(data.description||data.message||'Unable to add to bag');
    status.replaceChildren(document.createTextNode('Added to your bag. '));
    const a=document.createElement('a');a.href=(form.action||'').replace(/\/add(?:\?.*)?$/,'');a.textContent='View bag';status.appendChild(a);
    document.dispatchEvent(new CustomEvent('cart:refresh'));document.dispatchEvent(new CustomEvent('cp:cart-added', { detail: { trigger: add } }));addText.textContent='Added ✓';
   }catch(err){status.textContent=err.message||'Please try again';}
   finally{setTimeout(()=>{add.disabled=!current.available;addText.textContent=current.available?'Add to bag':'Unavailable'},1600);}
  });
  render(current,false);showSlide(0);
 }
 function boot(el){(el||document).querySelectorAll('[data-cp-config]').forEach(init)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
 document.addEventListener('shopify:section:load',e=>boot(e.target));
})();